import { useNotifyMutationError } from "@/lib/common/useNotifyMutationError";
import { useNotifyMutationSuccess } from "@/lib/common/useNotifyMutationSuccess";
import type { HTTPResponse, ProblemResponse } from "@/lib/http";
import type { UseMutationResult } from "@tanstack/react-query";

export const useNotifyMutationResult = <T, U>(mutation: UseMutationResult<HTTPResponse<T>, ProblemResponse, U>, title: string, description?: string) => {
	useNotifyMutationSuccess(mutation, title, description);
	useNotifyMutationError(mutation);
};
